import { CSSProperties, FC } from "react";
import {
  ImageSourcePropType,
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import { kColors } from "../kColors";
import { SLImage } from "./ReactiveImage";

type tAlertType = "error" | "warning" | "success";

interface tAlertProps {
  message: string;
  alertType: tAlertType;
  onClose: () => void;
}

const redClose = { uri: "close-red.png" };
const yellowClose = { uri: "close-yellow.png" };
const greenClose = { uri: "close-green.png" };

const Alert: FC<tAlertProps> = ({ message, alertType, onClose }) => {
  let aContainerStyle: StyleProp<ViewStyle> = {};
  let aTextStyle: StyleProp<TextStyle> = {};
  let closeImg: ImageSourcePropType = redClose;
  if (alertType === "success") {
    aContainerStyle = {
      backgroundColor: kColors.greenLight,
      borderColor: kColors.green,
    };
    aTextStyle = {
      color: kColors.green,
      fontWeight: "bold",
    };
    closeImg = greenClose;
  } else if (alertType === "warning") {
    aContainerStyle = {
      backgroundColor: kColors.yellowLight,
      borderColor: kColors.yellow,
    };
    aTextStyle = {
      color: kColors.yellow,
      fontWeight: "bold",
    };
    closeImg = yellowClose;
  } else if (alertType === "error") {
    aContainerStyle = {
      backgroundColor: kColors.redLight,
      borderColor: kColors.red,
    };
    aTextStyle = {
      color: kColors.red,
      fontWeight: "bold",
    };
  }

  return (
    <View style={[styles.alert, aContainerStyle]}>
      <Text style={aTextStyle}>{message}</Text>
      <TouchableOpacity onPress={onClose}>
        <SLImage source={closeImg} mobileStyle={styles.alertClose} webStyle={webStyles.alertClose} />
      </TouchableOpacity>
    </View>
  );
};

export default Alert;

const styles = StyleSheet.create({
  alert: {
    alignItems: "center",
    borderRadius: 5,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 8,
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  alertClose: {
    height: 10,
    width: 10,
  },
});

const webStyles: { [key: string]: CSSProperties } = {
  alertClose: {
    height: 10,
    width: 10,
  },
} as const;
